
const digest = 'b91c899d397caef0c4082c5973b1869de593a9c1da0a16b8ecc88887f7b55528';
const classes = {"wrapper":"_wrapper_1ujwo_1"};
const css = `._wrapper_1ujwo_1 {
  display: flex;
  flex-direction: row;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  